<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2.46967 10.7802C2.17678 10.4873 2.17678 10.0124 2.46967 9.71952L6.3383 5.85089C6.3445 5.84469 6.35068 5.83851 6.35684 5.83234C6.5389 5.65026 6.7061 5.48304 6.85731 5.35467C7.02033 5.21628 7.21339 5.07959 7.45922 4.99971C7.8107 4.88551 8.1893 4.88551 8.54078 4.99971C8.78661 5.07959 8.97967 5.21628 9.14269 5.35467C9.2939 5.48304 9.46111 5.65027 9.64316 5.83235L9.6617 5.85089L13.5303 9.71952C13.8232 10.0124 13.8232 10.4873 13.5303 10.7802C13.2374 11.0731 12.7626 11.0731 12.4697 10.7802L8.60104 6.91155C8.39428 6.70479 8.27069 6.58203 8.17193 6.49818C8.11165 6.44701 8.08222 6.42959 8.07399 6.42526C8.02579 6.41033 7.9742 6.41033 7.92601 6.42526C7.91778 6.42959 7.88835 6.44701 7.82807 6.49818C7.72931 6.58203 7.60572 6.70479 7.39896 6.91155L3.53033 10.7802C3.23744 11.0731 2.76256 11.0731 2.46967 10.7802Z"
    fill="currentColor"
  />
</svg>
